export default __webpack_public_path__ + "static/media/vadim.557b1308.jpg";